import { render } from "./siteFooter.vue?vue&type=template&id=b46aef06&scoped=true&ts=true"
import script from "./siteFooter.vue?vue&type=script&lang=ts"
export * from "./siteFooter.vue?vue&type=script&lang=ts"

import "./siteFooter.vue?vue&type=style&index=0&id=b46aef06&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46aef06"]])

export default __exports__